import { useTranslation } from "react-i18next"

import {
  type PersonNameOrder,
  resolvePersonNameOrder,
} from "@/utils/person-name"

export const usePersonNameOrder = (): PersonNameOrder => {
  const { i18n } = useTranslation()

  return resolvePersonNameOrder(i18n.language)
}
